


<div [ngClass]="{'container-fluid': fullWidthView$ | async, 'container': !(fullWidthView$ | async)}">

  <div class="row" style="padding-top: 25px;">
    <div class="col-md-12">

      <!-- heading and intro -->
      <h1>{{ 'checkout.title-summary' | translate }}</h1>

      <p class="greatsuccess">
          <strong><i class="fa fa-check"></i>  {{ 'checkout.title-success' | translate }}.</strong>
      </p>

      <div class="ordernumber">
          {{ 'checkout.ordernumber' | translate }}: {{order?.ordernumber}}
      </div>

    </div>
  </div>

  <div class="row">
    <div class="col-lg-7 col-md-7 col-sm-12">

      <!-- cart heading
      <h3 class="with-line">{{ 'checkout.products' | translate }}</h3>
      -->

      <!-- cart -->
      <app-cart-table
        *ngIf="order"
        [editable]="false"
        [order]="order"
        [quantityPicker]="quantityPicker"
        [currency]="currency"
        [showUomInfoForUoms]="checkoutPageSettings?.showUomInfoForUoms"
        [showFacets]="checkoutPageSettings?.showFacets"
        [extraCosts]="extraCosts">
      </app-cart-table>

      <!-- disclaimer -->
      <p class="disclaimer">
        {{ 'checkout.disclaimer' | translate }}
      </p>

    </div>
    <div class="col-lg-5 col-md-5 col-sm-12">

      <div class="address-delivery-details">

        <!--
        <h3 class="with-line">{{ 'checkout.details' | translate }}</h3>
        -->

        <!-- afleveradres etc-->
        <!-- order details ADDRESS / DATE -->

        <!-- address -->
        <div style="margin-bottom:35px;">
          <h3 class="with-line">{{ 'checkout.delivery-address' | translate }}</h3>
          <app-address *ngIf="address" [address]="address">
          </app-address>
        </div>

        <!-- delivery date -->
        <h3 class="with-line">{{ 'checkout.delivery-date' | translate }}</h3>
        <p style="margin-bottom: 35px;">
           <i class="fa fa-calendar" style="margin-right:15px;"></i> {{deliveryDate}}
        </p>

        <div *ngIf="order?.customerReference">
          <!-- reference -->
          <h3 class="with-line">{{ 'checkout.reference-title' | translate }}</h3>
          <p style="margin-bottom: 35px;">
            {{order?.customerReference | filler:'Geen referentie'}}
          </p>
        </div>

        <div *ngIf="order?.comments">
          <!-- remarks -->
          <h3 class="with-line">{{ 'checkout.remarks' | translate }}</h3>
          <p>
            {{order?.comments | filler:'Geen opmerkingen'}}
          </p>
        </div>

      </div>

    </div>
  </div>


</div> <!-- // end container -->
